import { createSlice } from "@reduxjs/toolkit";
import { InterventionsData } from "../types/interventions";

const initialState = {
  addedLaps: 0,
  flagPeriods: [],
  cutoffTime: null,
} as InterventionsData;

export const interventionsSlice = createSlice({
  name: "interventions",
  initialState,
  reducers: {
    setInterventionsData: (state, action) => {
      const interventionsData = action.payload;

      if (interventionsData.addedLaps != null) {
        state.addedLaps = interventionsData.addedLaps;
      }
      if (interventionsData.flagPeriods != null) {
        state.flagPeriods = interventionsData.flagPeriods;
      }
      // Use -1 to explicitly clear cutoffTime
      if (interventionsData.cutoffTime === -1) {
        state.cutoffTime = null;
      } else if (interventionsData.cutoffTime != null) {
        state.cutoffTime = interventionsData.cutoffTime;
      }
    },
  },
});

export const { setInterventionsData } = interventionsSlice.actions;
export default interventionsSlice.reducer;
